import { FC } from 'react';
import { ActionIconStar, ActionIconHeart } from '@vs-online-only-app/ui';
import { Chip, Stack, Typography } from '@mui/material';

type Props = {
  type: 'new' | 'familiar';
};

const yellow = '#FFD166';
const cyan = '#94F8FF';

export const ShopperBadge: FC<Props> = ({ type }) => {
  const isFamiliarShopper = type === 'familiar';
  return (
    <Chip
      size="small"
      label={
        <Stack direction="row" alignItems="center" gap={0.5}>
          {isFamiliarShopper ? <ActionIconHeart /> : <ActionIconStar />}
          <Typography variant="caption">
            {isFamiliarShopper ? 'Familiar face' : 'New'}
          </Typography>
        </Stack>
      }
      sx={{
        width: 'fit-content',
        background: isFamiliarShopper ? yellow : cyan,
      }}
    />
  );
};
